import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import { Flex } from 'reflexbox'

import styles from './styles.scss'

const Header = (props) => {
  const { label, children } = props
  return (
    <Flex styleName='header' justify='space-between'>
      <h3>{ label }</h3>
      <Flex align='center' justify='space-around'>
        { children }
      </Flex>
    </Flex>
  )
}

Header.propTypes = {
  label: PropTypes.string.isRequired,
}

Header.defaultProps = {
  label: 'Change this header'
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(Header)

